export type ButtonType = 'link' | 'button' | 'submit';
export type ButtonTemplate = 'white-md' | 'dark';

export const TEMPLATES = {
    'white-md': {
        height: 'h-12',
        width: 'w-40',
        fontColor: 'black',
        hoverFontColor: '',
        backgroundColor: 'white-80',
        hoverBackgroundColor: 'white',
        disabledBackgroundClass: 'gray-200',
        font: 'base-text-size-7 font-medium uppercase',
    },
    'dark': {
        height: 'h-20',
        width: '',
        fontColor: 'white',
        hoverFontColor: '',
        backgroundColor: 'boon-black',
        hoverBackgroundColor: 'gray-600',
        disabledBackgroundClass: 'gray-400',
        addtlContentClasses: '',
        font: 'base-text-size-7',
    },
};
